'use client';

import {
  ArrowLeft,
  Package,
  BookOpen,
  MessageCircle,
  ArrowRight,
} from 'lucide-react';
import Link from 'next/link';

export default function NotFound() {
  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="flex justify-center mb-8">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
            <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
            404 error
          </span>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 text-center mb-4">
          We can&apos;t find this page
        </h1>

        <p className="text-lg text-gray-600 text-center mb-10">
          The page you are looking for doesn&apos;t exist or has been moved.
        </p>

        <div className="flex flex-wrap gap-3 justify-center mb-16">
          <button
            onClick={goBack}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Go back
          </button>
          <Link
            href="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors"
          >
            Go home
          </Link>
        </div>

        <div className="space-y-3">
          <Link
            href="/invoices"
            className="flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-colors group"
          >
            <div className="shrink-0 w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center">
              <Package className="w-5 h-5 text-gray-700" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-0.5">Invoices</h3>
              <p className="text-sm text-gray-600">
                Dive in to learn all about our product.
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
          </Link>

          <Link
            href="/clients"
            className="flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-colors group"
          >
            <div className="shrink-0 w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center">
              <BookOpen className="w-5 h-5 text-gray-700" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-0.5">Clients</h3>
              <p className="text-sm text-gray-600">
                Read the latest posts on our blog.
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
          </Link>

          <Link
            href="/products"
            className="flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-colors group"
          >
            <div className="shrink-0 w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center">
              <MessageCircle className="w-5 h-5 text-gray-700" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-0.5">Products</h3>
              <p className="text-sm text-gray-600">
                Can&apos;t find what you&apos;re looking for?
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
          </Link>
        </div>
      </div>
    </div>
  );
}
